var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bottomBox"},_vm._l((_vm.bottomBtnList),function(item,index){return _c('div',{key:index,staticClass:"btn",on:{"click":function($event){return _vm.btnClick(index+1)}}},[_c('div',{staticClass:"btnIcon"},[_c('img',{attrs:{"src":item.iconImage,"alt":""}})]),_c('div',{staticClass:"btnMain"},[_vm._v(_vm._s(item.name))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }